<div class="relative" style="overflow: hidden">
  <div class="cf wrapper relative">
    <span class="icon icon-info icon--header-background"></span>
    <div class="col small_12" style="position: relative; z-index: 1">
      <h1 class="tera primary-font push-half--bottom white" tabindex="0">
        {{ pageTitle }}
      </h1>
    </div>
  </div>
</div>
<div class="wrapper wrap pb-120 soft--medium pull-up">
  <div class="row mt-4">
    <div class="col-sm-3" style="padding: 0px !important;">
      <ul class="menu-naviagtion">
        <li
          *ngFor="let option of accountLinks"
          [class.selected]="option === selectedOption"
          (click)="onSelect(option)"
        >
          <span>{{ option }}</span>
        </li>
      </ul>
    </div>

    <div class="col-sm-9">
      <app-my-account *ngIf="selectedOption === 'Account'"></app-my-account>
      <app-change-password
        *ngIf="selectedOption === 'Change password'"
      ></app-change-password>
      <app-upcoming-bookings
        *ngIf="selectedOption === 'Upcoming bookings'"
      ></app-upcoming-bookings>
      <app-past-bookings
        *ngIf="selectedOption === 'Past bookings'"
      ></app-past-bookings>
    </div>
  </div>
</div>
